import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';

@Component({
    selector: 'advice-message',
    templateUrl: './advice-message.component.html',
    standalone: true,
    imports: [AfTranslatePipe]
})
export class AdviceMessageComponent implements OnInit {
  adviceMessage: any = {
    icon: ''
  };
  constructor() { }

  @Input() type: string = '';
  @Input() text:any = null;
  @Input() showCloseButton: boolean = true;
  @Output() closeAdvice = new EventEmitter();

  ngOnInit(): void {
    switch(this.type){
      case 'info':
      case 'warning':
        this.adviceMessage.icon = 'lf-icon-'+this.type+'-full';
        break;
      case 'success':
        this.adviceMessage.icon = 'lf-icon-check-round-full';
        break;
      case 'alert':
        this.adviceMessage.icon = 'lf-icon-close-round-full';
        break;
    }
  }

  closeBox(){
    this.closeAdvice.emit();
  }

}
